import { useDispatch, useSelector } from "react-redux"
import * as service from "../service/StpTimeSheetApi"
import { useCallback, useEffect, useMemo } from "react"
import { setEmployeeList, setIsLoading } from "../slices/TimeSheetSlice"
import { Flex, message, Modal } from "antd"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"

function useCreateSettingProject() {
    const { t } = useTranslation();
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { i18n } = useTranslation()
    const { currentCompany, currentEmployee } = useSelector((state) => state.company)
    const { isLoading, employeeList } = useSelector((state) => state.timeSheet)

    const PROJECT_STATUS = useMemo(() => {
        return [
            {
                value: "PENDING",
                label: i18n.language === 'en' ? "Pending" : "รอดำเนินการ"
            },
            {
                value: "INPROGRESS",
                label: i18n.language === 'en' ? "In progress" : "กำลังดำเนินการ"
            },
            {
                value: "COMPLETE",
                label: i18n.language === 'en' ? "Complete" : "ดำเนินการเสร็จแล้ว"
            },
        ]
    }, [i18n.language])


    const employeeOptions = useMemo(() => {
        return employeeList?.map((o) => {
            return {
                ...o,
                label: i18n.language === 'en' ? o?.fullNameEn : o?.fullName,
                value: o?.id
            }
        })
    }, [employeeList, i18n.language])

    const onSubmit = useCallback(async (params) => {
        try {
            dispatch(setIsLoading(true))
            const res = await service.editStpTimeSheet({
                ...params,
                companyId: currentCompany,
                employeeId: currentEmployee,
                ownerListId: [params?.ownerListId],
                forAll: params?.forAll ? "Y" : "N"
            })

            if (res.content?.code === '400') {
                Modal.error({
                    content: res.content.details[0].value,
                    okText: t('message.ok'),
                })
            } else {
                message.success(t("common.success"))
                navigate("/setting_timesheet/setting_project")
            }
        } catch (error) {
            const errorDetail = error.response?.data?.content?.details?.[0]?.value

            if (errorDetail) {
                Modal.error({
                    content: errorDetail,
                    okText: t('message.ok'),
                })
            } else {
                message.error(t("common.error"))
            }
        } finally {
            dispatch(setIsLoading(false))
        }
    }, [currentCompany, currentEmployee])

    const getDropdownEmployee = useCallback(async (params) => {
        dispatch(setIsLoading(true))
        await service.dropdownEmployee({
            ...params,
            companyId: currentCompany,
            employeeId: currentEmployee
        }).then((res) => {
            dispatch(setEmployeeList(res?.data || []))
        }).catch((error) => {

        }).finally((o) => {

            dispatch(setIsLoading(false))
        })
    }, [currentCompany, currentEmployee])


    useEffect(() => {
        if (currentCompany) {
            getDropdownEmployee();
        }
    }, [currentCompany])

    return {
        onSubmit,
        isLoading,
        employeeOptions,
        PROJECT_STATUS,
        getDropdownEmployee,
        employeeList
    }
}

export default useCreateSettingProject;